export default "__VITE_ASSET__DkKQi71D__"